import { Splide } from '@hh/global.js'

class SearchImageCarousel extends HTMLElement {
  constructor() {
    super()

    this.splide = null
    this.initialized = false
  }

  connectedCallback() {
    requestAnimationFrame(() => {
      this.init()
    })
  }

  disconnectedCallback() {
    if (this.splide) {
      this.splide.destroy(true)
      this.splide = null
    }

    this.initialized = false
  }

  init() {
    const carouselEl = this.querySelector('.js-carousel-container')

    if (!carouselEl) return

    if (this.initialized && this.splide) {
      return
    }

    if (
      carouselEl.classList.contains('is-initialized') &&
      !carouselEl.classList.contains('is-active')
    ) {
      carouselEl.classList.remove('is-initialized', 'is-active', 'is-overflow')
    }

    const slides = carouselEl.querySelectorAll('.splide__slide')
    const hasMultipleSlides = slides.length > 1

    this.splide = new Splide(carouselEl, {
      arrows: false,
      pagination: hasMultipleSlides,
      useScroll: true,
      mediaQuery: 'min',
      type: 'fade',
      cloneStatus: false,
      rewind: true,
      start: 0,
      breakpoints: {
        768: {
          pagination: hasMultipleSlides,
          arrows: hasMultipleSlides,
          type: 'fade',
          cloneStatus: false,
          rewind: true,
          start: 0,
        },
      },
    })

    this.splide.mount()

    this.initialized = true

    this.disablePaginationFocus(carouselEl)
  }

  disablePaginationFocus(carouselEl) {
    const buttons = carouselEl.querySelectorAll('.splide__pagination__page')

    buttons.forEach((btn) => {
      btn.setAttribute('tabindex', '-1')
      btn.setAttribute('aria-hidden', 'true')
      btn.blur()

      btn.addEventListener('focus', (e) => {
        e.target.blur()
      })
    })
  }
}

customElements.define('search-image-carousel', SearchImageCarousel)
